import React from 'react';
import { FormCheckBoxLabel, FormRadioInputBox } from '@styled/Form';
export default function RadioInput(_a) {
    var checked = _a.checked, category = _a.category, action = _a.action, label = _a.label, css = _a.css, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (React.createElement(FormRadioInputBox, { onClick: disabled ? undefined : action, style: css, "$disabled": disabled },
        React.createElement("input", { type: "radio", id: "html", name: category, checked: checked, onChange: disabled ? undefined : action }),
        label !== undefined && React.createElement(FormCheckBoxLabel, null, label)));
}
